import React from 'react';

type LineBreakProps = {
  height: number;
};

export const LineBreak = (props: LineBreakProps) => {
  return <div className="line-break" style={{ height: props.height }}></div>;
};
